module.exports = __webpack_public_path__ + "img/gaokao_after_top.ab1d29dd.png";